import React from "react"

export const RecipeContext = React.createContext({
    recipe: null,
    doughWeight: null
});
